import { Rest as MasterRest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $processing, $done } from '../activity/action';
import { $failure, $requesting, $success } from '../form/action';

export const MODULE = 'Notification';
const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;
const Rest = MasterRest.disableNotify();

export const $setDevice = ActionCreator.Async(
  MODULE,
  'setDevice',
  (payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());
      return await Rest.POST(`${API_URL}/notification/set/device`, payload)
        .then((response) => {
          dispatch($success.action());
          return true;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $get = ActionCreator.Async(MODULE, 'Get', () => {
  return async (dispatch) => {
    dispatch($processing($get.OPERATION));

    return await Rest.GET(`${API_URL}/notification`, { apps: 'tms' })
      .then((response) => {
        dispatch($get.success({ response }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($get.OPERATION)));
  };
});

export const $markRead = ActionCreator.Async(MODULE, 'markRead', (id) => {
  return async (dispatch) => {
    return await Rest.POST(`${API_URL}/notification/mark/read/${id}`, {})
      .then((response) => {
        dispatch($markRead.success({ id }));
        return true;
      })
      .catch((error) => {
        return false;
      });
  };
});

export const $newNotif = ActionCreator.Default(MODULE, 'newNotif', (payload) =>
  $newNotif.action({ payload })
);

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);
